/* 每個功能區塊各自包 try/catch：任何一段出錯，不會拖垮後面的區塊（進場動畫保底、購物車救援、選單等） */
function svSafe(fn){ try{ fn(); }catch(e){ if(window.console&&console.warn) console.warn('[stepv]',e); } }
/* theme.liquid 內嵌 JS 搬出：搜尋面板、影片延遲載入、LINE 浮動鈕、進場動畫、導覽列滾動。以 defer 載入，執行時 DOM 已解析完成。 */
svSafe(function(){
  // 搜尋面板
  (function(){
    var sb=document.getElementById('sv-search-btn'), panel=document.getElementById('sv-search'),
        inp=document.getElementById('sv-search-input'), cl=document.getElementById('sv-search-close');
    if(!sb||!panel) return;
    function open(){ panel.hidden=false; sb.setAttribute('aria-expanded','true'); setTimeout(function(){ inp && inp.focus(); },30); }
    function close(){ panel.hidden=true; sb.setAttribute('aria-expanded','false'); }
    sb.addEventListener('click', function(){ panel.hidden ? open() : close(); });

    // ---- 即時建議 ----
    // Shopify Predictive Search API 不支援中文（417 Unsupported buyer locale），
    // 改成第一次聚焦時抓 sections/sv-search-index.liquid 產生的索引，在瀏覽器端比對。
    var sug=document.getElementById('sv-sug'), timer=null, lastQ='', IDX=null, loading=false;
    var SEARCH_URL=(window.svRoutes&&window.svRoutes.search)||'/search', ROOT=(window.svRoutes&&window.svRoutes.root)||'/';
    function esc(t){ return String(t==null?'':t).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
    function hideSug(){ sug.hidden=true; sug.innerHTML=''; }
    // 索引載入：下載中的 callback 排隊，完成後全部回呼（修正「focus 先載、輸入時 loading 直接 return、字打完沒結果」的競態）
    var pending=[];
    function loadIdx(cb){
      if(IDX){ cb(IDX); return; }
      pending.push(cb); if(loading) return; loading=true;
      var u=(ROOT==='/'?'':ROOT.replace(/\/$/,''))+'/?section_id=sv-search-index';
      fetch(u).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.text(); }).then(function(html){
        var d=new DOMParser().parseFromString(html,'text/html'); var el=d.getElementById('sv-search-index'); var idx;
        try{ idx=el?JSON.parse(el.textContent):null; }catch(e){ idx=null; }
        IDX=idx||{products:[],articles:[],pages:[]}; loading=false;
        var q=pending.splice(0); q.forEach(function(f){ try{ f(IDX); }catch(e){} });
      }).catch(function(){
        loading=false; pending.splice(0);
        if(sug && inp && inp.value.trim()){ sug.innerHTML='<div class="sv-sug-in"><div class="sv-sug-empty">搜尋建議暫時無法載入，請按 Enter 直接搜尋</div></div>'; sug.hidden=false; }
      });
    }
    function match(list,q,limit){
      var terms=q.toLowerCase().split(/\s+/).filter(Boolean), out=[];
      list.forEach(function(x){
        var t=(x.t||'').toLowerCase(), k=(x.k||''), score=0;
        var ok=terms.every(function(w){ if(t.indexOf(w)>-1){score+=3;return true;} if(k.indexOf(w)>-1){score+=1;return true;} return false; });
        if(ok) out.push({s:score+(x.a===false?-1:0),x:x});
      });
      return out.sort(function(a,b){return b.s-a.s;}).slice(0,limit).map(function(o){return o.x;});
    }
    function render(q,idx){
      var p=match(idx.products||[],q,6), a=match(idx.articles||[],q,4), g=match(idx.pages||[],q,3), html='';
      if(p.length){
        html+='<div class="sv-sug-h">商品</div>';
        p.forEach(function(x){
          html+='<a class="sv-sug-item" href="'+esc(x.u)+'">'+(x.i?'<img src="'+esc(x.i)+'" alt="" loading="lazy" width="44" height="44">':'<span class="sv-sug-ph"></span>')
              +'<span class="sv-sug-t"><b>'+esc(x.t)+'</b><i>'+esc(x.p)+(x.c?' <s>'+esc(x.c)+'</s>':'')+(x.a===false?' <em>補貨中</em>':'')+'</i></span></a>';
        });
      }
      if(a.length){ html+='<div class="sv-sug-h">文章</div>'; a.forEach(function(x){ html+='<a class="sv-sug-item" href="'+esc(x.u)+'">'+(x.i?'<img src="'+esc(x.i)+'" alt="" loading="lazy" width="44" height="44">':'<span class="sv-sug-ph"></span>')+'<span class="sv-sug-t"><b>'+esc(x.t)+'</b><i class="sv-sug-b">'+esc(x.b)+'</i></span></a>'; }); }
      if(g.length){ html+='<div class="sv-sug-h">頁面</div>'; g.forEach(function(x){ html+='<a class="sv-sug-item sv-sug-txt" href="'+esc(x.u)+'"><span class="sv-sug-t"><b>'+esc(x.t)+'</b></span></a>'; }); }
      if(!html){ html='<div class="sv-sug-empty">找不到「'+esc(q)+'」相關內容</div>'; }
      html+='<a class="sv-sug-all" href="'+SEARCH_URL+'?q='+encodeURIComponent(q)+'&options%5Bprefix%5D=last">查看「'+esc(q)+'」的全部結果 →</a>';
      sug.innerHTML='<div class="sv-sug-in">'+html+'</div>'; sug.hidden=false;
    }
    if(inp){
      inp.addEventListener('focus',function(){ loadIdx(function(){}); });
      inp.addEventListener('input',function(){
        var q=inp.value.trim(); lastQ=q; clearTimeout(timer);
        if(q.length<1){ hideSug(); return; }
        timer=setTimeout(function(){ loadIdx(function(idx){ if(q===lastQ) render(q,idx); }); },150);
      });
      inp.addEventListener('keydown',function(e){
        var items=sug.querySelectorAll('.sv-sug-item,.sv-sug-all'); if(!items.length) return;
        var i=Array.prototype.indexOf.call(items,document.activeElement);
        if(e.key==='ArrowDown'){ e.preventDefault(); items[Math.min(i+1,items.length-1)].focus(); }
      });
      sug.addEventListener('keydown',function(e){
        var items=sug.querySelectorAll('.sv-sug-item,.sv-sug-all'); var i=Array.prototype.indexOf.call(items,document.activeElement);
        if(e.key==='ArrowDown'){ e.preventDefault(); items[Math.min(i+1,items.length-1)].focus(); }
        if(e.key==='ArrowUp'){ e.preventDefault(); if(i<=0) inp.focus(); else items[i-1].focus(); }
      });
    }
    var _close=close; close=function(){ hideSug(); _close(); };
    cl && cl.addEventListener('click', hideSug);
    cl && cl.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !panel.hidden) close(); });
  })();
  var btn     = document.getElementById('sv-burger');
  var drawer  = document.getElementById('sv-drawer');
  var overlay = document.getElementById('sv-drawer-ov');
  var closeBtn= document.getElementById('sv-drawer-close');
  if(!btn || !drawer || !overlay) return;
  // 手機抽屜：開啟時焦點移入、Tab 鎖在抽屜內，關閉後焦點回到漢堡鈕
  var lastFocus=null;
  function focusables(){ return drawer.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'); }
  function open(){
    lastFocus=document.activeElement;
    drawer.classList.add('open'); overlay.classList.add('open');
    document.body.classList.add('sv-drawer-open');
    drawer.setAttribute('aria-hidden','false');
    btn.setAttribute('aria-expanded','true');
    setTimeout(function(){ var f=closeBtn||focusables()[0]; f && f.focus(); },30);
  }
  function close(){
    drawer.classList.remove('open'); overlay.classList.remove('open');
    document.body.classList.remove('sv-drawer-open');
    drawer.setAttribute('aria-hidden','true');
    btn.setAttribute('aria-expanded','false');
    (lastFocus||btn).focus && (lastFocus||btn).focus();
  }
  btn.addEventListener('click', open);
  if(closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if(!drawer.classList.contains('open')) return;
    if(e.key === 'Escape'){ close(); return; }
    if(e.key === 'Tab'){
      var f=focusables(); if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    }
  });
});

/* 文章／頁面 RTE 內的圖片：後台貼進來的原圖常是 5–6MB PNG。首屏之外加 lazy，並對 Shopify CDN 圖片加 width 參數讓 CDN 縮圖。 */
svSafe(function(){
  var imgs=document.querySelectorAll('.rte img, .article-template__content img, .nj img');
  if(!imgs.length) return;
  var vh=window.innerHeight||800;
  imgs.forEach(function(img){
    var r=img.getBoundingClientRect();
    if(r.top>vh*1.5 && !img.hasAttribute('loading')) img.setAttribute('loading','lazy');
    if(!img.hasAttribute('decoding')) img.setAttribute('decoding','async');
    var src=img.getAttribute('src')||'';
    // 已經載完的首屏圖不再改 src（避免重抓）；只處理尚未載入或在視窗外的
    if((!img.complete || r.top>vh) && /^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/|\/cdn\/shop\/files\//.test(src) && !/[?&]width=/.test(src) && !img.hasAttribute('srcset')){
      var w=Math.min(1600, Math.max(600, Math.ceil((img.clientWidth||1200)*(window.devicePixelRatio||1)/100)*100));
      img.setAttribute('src', src+(src.indexOf('?')>-1?'&':'?')+'width='+w);
    }
  });
});

/* 文章目錄錨點：Shopify 文章編輯器會把 heading 上的 id 拿掉，目錄的 #why-hot 之類連結就找不到目標。
   這裡在前端把「目錄連結文字」對到「同文字的標題」補回 id；已存在的目標不動。補完後若網址本身帶 #，順便捲過去。 */
svSafe(function(){
  var rte=document.querySelector('.article-template__content, .rte'); if(!rte) return;
  var norm=function(t){ return (t||'').replace(/\s+/g,'').replace(/[｜|：:、,，.。！!？?（）()\[\]「」]/g,'').toLowerCase(); };
  var heads=Array.prototype.slice.call(rte.querySelectorAll('h1,h2,h3,h4,h5'));
  var fixed=0;
  rte.querySelectorAll('a[href^="#"]').forEach(function(a){
    var id=decodeURIComponent(a.getAttribute('href').slice(1)); if(!id || document.getElementById(id)) return;
    var t=norm(a.textContent); if(!t) return;
    var h=null;
    for(var i=0;i<heads.length;i++){ var ht=norm(heads[i].textContent); if(ht===t){ h=heads[i]; break; } }
    if(!h) for(var j=0;j<heads.length;j++){ var ht2=norm(heads[j].textContent); if(ht2 && (ht2.indexOf(t)>-1 || t.indexOf(ht2)>-1) && !heads[j].id){ h=heads[j]; break; } }
    // 第三層：只比「：」之前的主標（例：目錄寫「…：百圓生醫的設計方向」、標題寫「…：營養正義的設計方向」）
    if(!h){ var pre=norm((a.textContent||'').split(/[：:｜|]/)[0]); if(pre.length>=6) for(var k=0;k<heads.length;k++){ var hp=norm((heads[k].textContent||'').split(/[：:｜|]/)[0]); if(hp===pre && !heads[k].id){ h=heads[k]; break; } } }
    if(h && !h.id){ h.id=id; fixed++; }
  });
  if(fixed && location.hash){ var target=document.getElementById(decodeURIComponent(location.hash.slice(1))); if(target) setTimeout(function(){ target.scrollIntoView(); },50); }
});

/* 結帳卡住自救：購物車頁探測 /checkout 是否落在 /processing；重建購物車（新 cart token）後回購物車頁讓客人重選配送。
   v2（2026-09-24 稽核後）：刪 cookie 後先確認 token 真的換新才重加商品（否則會變 2 件）；重加失敗就把舊 cookie 放回去；
   手動與自動都回 /cart 而不是直接進結帳（要重選門市／配送）。 */
svSafe(function(){
  var btns=document.querySelectorAll('[data-sv-rescue]'); if(!btns.length) return;
  var box=document.getElementById('sv-cart-rescue'), msgEl=box&&box.querySelector('.sv-rescue-msg');
  function say(t){ if(msgEl) msgEl.textContent=t; }
  function readCookie(name){ var m=document.cookie.match(new RegExp('(?:^|; )'+name+'=([^;]*)')); return m?m[1]:null; }
  function killCookie(name){
    var host=location.hostname, parts=host.split('.'), domains=[''];
    for(var i=0;i<parts.length-1;i++){ domains.push(parts.slice(i).join('.')); domains.push('.'+parts.slice(i).join('.')); }
    domains.forEach(function(d){ document.cookie=name+'=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'+(d?'; domain='+d:''); });
  }
  function restoreCookie(name,val){ if(val!==null) document.cookie=name+'='+val+'; path=/; secure; samesite=lax'; }
  function getCart(){ return fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){ if(!r.ok) throw new Error('cart '+r.status); return r.json(); }); }
  function fail(t){ say(t); btns.forEach(function(b){ b.disabled=false; }); }
  function rebuild(auto){
    btns.forEach(function(b){ b.disabled=true; });
    say(auto?'上一次結帳已卡住超過 3 分鐘，正在為你重新建立購物車…':'正在重新建立購物車…');
    var oldCookie=readCookie('cart'), oldToken=null, items=[];
    getCart().then(function(cart){
      oldToken=cart.token;
      items=(cart.items||[]).map(function(i){ var o={id:i.variant_id, quantity:i.quantity}; if(i.properties&&Object.keys(i.properties).length) o.properties=i.properties; if(i.selling_plan_allocation&&i.selling_plan_allocation.selling_plan) o.selling_plan=i.selling_plan_allocation.selling_plan.id; return o; });
      if(!items.length){ throw new Error('empty'); }
      ['cart','cart_sig','cart_ts','cart_ver','cart_currency'].forEach(killCookie);
      return getCart();
    }).then(function(fresh){
      // 關鍵檢查：cookie 若沒刪成功，Shopify 會回同一個購物車 → 絕不能再 add（會變兩倍）
      if(!fresh || fresh.token===oldToken || (fresh.items&&fresh.items.length)){ restoreCookie('cart',oldCookie); throw new Error('same-cart'); }
      return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){ if(!r.ok) throw new Error('add '+r.status); return r.json(); });
    }).then(function(){
      return getCart();
    }).then(function(after){
      var want=items.reduce(function(n,i){return n+i.quantity;},0);
      if(!after || after.token===oldToken || after.item_count!==want){ throw new Error('verify'); }
      say('已重新建立購物車，請重新選擇配送方式後結帳。');
      location.replace('/cart?rebuilt=1');
    }).catch(function(e){
      console.error('[rescue]',e);
      if(String(e.message)==='empty'){ fail('購物車是空的，請重新加入商品。'); return; }
      if(String(e.message)==='same-cart'){ fail('瀏覽器不允許重設購物車。請清空購物車後重新加入商品，或改用其他瀏覽器。'); return; }
      // add 失敗或驗證失敗：把舊 cookie 放回去，客人的原購物車不會消失
      restoreCookie('cart',oldCookie);
      fail('重建失敗，已保留原購物車。請清空購物車後重新加入商品，或改用其他瀏覽器。');
    });
  }
  btns.forEach(function(b){ b.addEventListener('click', function(){ rebuild(false); }); });
  // 探測：/checkout 會 302 到 /checkouts/cn/<token>/...；若最終網址含 /processing 就是卡住。
  // 自動重建：AUTO_MIN 為分鐘數；0 = 關閉（只顯示提示與按鈕，由客人自己按）。
  // 2026-09-24 店家決定：止血期先關閉自動，只留手動；預購結束後依客服紀錄再決定是否改回 3。
  // 開啟時的邏輯：同一個卡住的結帳第一次被偵測到之後超過 AUTO_MIN 分鐘還卡著 → 直接重建（每個 token 只一次）。
  var AUTO_MIN=0;
  function store(k,v){ try{ if(v===undefined) return localStorage.getItem(k); localStorage.setItem(k,v); }catch(e){ return null; } }
  // 2026-09-29：探測改成「只在客人真的按過結帳之後」才發，不再每次看購物車都在背景開一個結帳工作階段。
  // 條件：(a) 從 /checkouts/ 回到購物車（referrer），或 (b) 24 小時內在本站按過「結帳」（localStorage 旗標）。
  document.querySelectorAll('[name="checkout"]').forEach(function(b){ b.addEventListener('click', function(){ store('sv_ck_try', String(Date.now())); }); });
  var tried=parseInt(store('sv_ck_try')||'0',10);
  var shouldProbe = /\/checkouts\//.test(document.referrer||'') || (tried && Date.now()-tried < 86400000);
  if(box && window.fetch && shouldProbe && !/[?&]rebuilt=1/.test(location.search)){
    fetch('/checkout',{credentials:'same-origin',redirect:'follow'}).then(function(r){
      var m=r && r.url && r.url.match(/\/checkouts\/[a-z]{2}\/([A-Za-z0-9]+)\/[^?]*\/processing/); if(!m) return;
      var token=m[1], key='sv_stuck_'+token, now=Date.now(), first=parseInt(store(key)||'0',10);
      if(!first){ store(key,String(now)); first=now; }
      var stuckMin=(now-first)/60000;
      box.hidden=false;
      if(AUTO_MIN>0 && stuckMin>=AUTO_MIN && store('sv_rebuilt_'+token)!=='1'){
        store('sv_rebuilt_'+token,'1');
        rebuild(true);
      }
    }).catch(function(){});
  }
});

/* 影片延遲載入：進入視窗（或 hero 在首屏）才掛 src 並播放，離開視窗暫停。data-src 由各 section 提供。 */
svSafe(function(){
  var vids=document.querySelectorAll('video.sv-lazy-video'); if(!vids.length) return;
  function load(v){ if(v.dataset.loaded) return; v.dataset.loaded='1'; v.src=v.dataset.src; v.load(); }
  function play(v){ load(v); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
  if(!('IntersectionObserver' in window)){ vids.forEach(play); return; }
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ play(e.target); } else if(e.target.dataset.loaded){ e.target.pause(); } }); },{rootMargin:'200px 0px'});
  var mobile = window.innerWidth < 769;
  vids.forEach(function(v){
    var eager = v.className.indexOf('sv-lazy-video--eager')>=0;
    if(eager && mobile){
      /* 手機：首屏影片先顯示封面，等頁面載入完成再延後 800ms 才抓影片，避免跟 CSS／字型／圖片搶連線 */
      var go=function(){ setTimeout(function(){ play(v); io.observe(v); },800); };
      if(document.readyState==='complete') go(); else window.addEventListener('load',go,{once:true});
      return;
    }
    if(eager) play(v);
    io.observe(v);
  });
});

svSafe(function(){
  var b=document.querySelector('.line-float-btn'); if(!b) return;
  var t=false, T=80, bars=[];
  /* 找出頁面上其他「貼底的 fixed 元件」（例如預購頁的倒數購買列），LINE 鈕自動往上讓開 */
  function scan(){
    bars=[];
    /* 只檢查可能是貼底列的候選元素（body/section/main 直接子層、class 含 bar/sticky/fixed 者），避免對全頁元素做 getComputedStyle 造成強制重排 */
    var all=document.body.querySelectorAll('body > *, .shopify-section > *, main > *, .cf-bar, [class*="bar"], [class*="sticky"], [class*="fixed"]');
    for(var i=0;i<all.length;i++){
      var el=all[i]; if(el===b||el.closest('.line-float-btn')) continue;
      var cs=getComputedStyle(el);
      if(cs.position==='fixed' && (cs.bottom==='0px' || parseInt(cs.bottom,10)<=8)){ bars.push(el); }
    }
  }
  function upd(){
    var y=window.scrollY||document.documentElement.scrollTop; b.classList.toggle('is-mini', y>T);
    var vh=window.innerHeight, lift=0;
    for(var i=0;i<bars.length;i++){
      var r=bars[i].getBoundingClientRect();
      if(r.height>=30 && r.height<=220 && r.bottom>=vh-2 && r.top<vh){ lift=Math.max(lift, vh-r.top); }
    }
    b.style.bottom = lift ? (lift+12)+'px' : '';
    t=false;
  }
  var late;
  window.addEventListener('scroll',function(){ if(!t){ t=true; requestAnimationFrame(upd); } clearTimeout(late); late=setTimeout(upd,650); },{passive:true});
  window.addEventListener('resize',function(){ scan(); upd(); });
  scan(); upd(); setTimeout(function(){ scan(); upd(); },1500);
});

svSafe(function(){
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(e){
      e.forEach(function(i){if(i.isIntersecting){i.target.classList.add('visible');obs.unobserve(i.target);}});
    },{threshold:.08,rootMargin:'0px 0px -32px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el);});
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('visible');});
  }
  /* 保險：3 秒後不管 IntersectionObserver 有沒有觸發，全部進場元素直接顯示（弱網、舊 WebView、App 內建瀏覽器） */
  setTimeout(function(){ document.documentElement.classList.add('sv-reveal-all'); },3000);
  var nav=document.querySelector('.nav');
  if(nav) window.addEventListener('scroll',function(){
    nav.style.boxShadow=window.scrollY>20?'0 4px 24px rgba(13,27,62,.08)':'none';
  },{passive:true});
  // 摺疊區：同步 aria-expanded；非 button 的標題補 Enter/Space 鍵盤操作
  document.querySelectorAll('.faq-q,.prod-spec-header,.pg-acc-header,.faith-acc-header').forEach(function(h){
    var toggle=function(){ var open=h.parentElement.classList.toggle('open'); h.setAttribute('aria-expanded', open?'true':'false'); };
    if(!h.hasAttribute('aria-expanded')) h.setAttribute('aria-expanded', h.parentElement.classList.contains('open')?'true':'false');
    if(h.tagName!=='BUTTON'){ if(!h.hasAttribute('tabindex')) h.setAttribute('tabindex','0'); if(!h.hasAttribute('role')) h.setAttribute('role','button');
      h.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } }); }
    h.addEventListener('click',toggle);
  });
  // 舊版 YouTube 佔位載入（目前無呼叫點，保留相容；修正清空父節點後取 parentElement 為 null 的錯誤）
  window.loadVideo=function(id){
    var ph=document.getElementById('video-ph');if(!ph)return;
    var wrap=ph.parentElement;if(!wrap)return;
    var iframe=document.createElement('iframe');
    iframe.src='https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0';
    iframe.allow='accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture';
    iframe.allowFullscreen=true;
    iframe.style.cssText='position:absolute;top:0;left:0;width:100%;height:100%;border:none;';
    wrap.innerHTML='';wrap.appendChild(iframe);
  };
  window.changeQty=function(d){var i=document.getElementById('qty-input');if(i)i.value=Math.max(1,(parseInt(i.value)||1)+d);};
  window.switchImg=function(thumb,src){
    document.querySelectorAll('.prod-thumb').forEach(function(t){t.classList.remove('active');});
    thumb.classList.add('active');
    var m=document.getElementById('main-img');if(m)m.src=src;
  };
  (function(){
    var slides=document.querySelectorAll('.hero-slide');
    var dots=document.querySelectorAll('.hero-dot');
    var cur=0;if(!slides.length)return;
    function goTo(n){
      slides[cur].classList.remove('active');
      if(dots[cur])dots[cur].classList.remove('active');
      cur=n;slides[cur].classList.add('active');
      if(dots[cur])dots[cur].classList.add('active');
    }
    var prev=document.querySelector('.hero-prev');
    var next=document.querySelector('.hero-next');
    if(prev)prev.addEventListener('click',function(){goTo((cur-1+slides.length)%slides.length);});
    if(next)next.addEventListener('click',function(){goTo((cur+1)%slides.length);});
    dots.forEach(function(d,i){d.addEventListener('click',function(){goTo(i);});});
    setInterval(function(){goTo((cur+1)%slides.length);},5500);
  })();
});

svSafe(function(){
  // A3: NAV 滾動縮小
  var nav = document.querySelector('.nav');
  if(nav){
    var scrollThreshold = 30;
    var ticking = false;
    function updateNav(){
      if(window.scrollY > scrollThreshold){
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){
        window.requestAnimationFrame(updateNav);
        ticking = true;
      }
    }, {passive: true});
    updateNav();
  }

  // A5: 數字遞增動畫
  // 使用方法：<span data-count-up="100" data-count-suffix="%">0</span>
  // data-count-up: 目標數字
  // data-count-suffix: 後綴（選填，如 "%" / "+" / "x"）
  // data-count-prefix: 前綴（選填，如 "$"）
  // data-count-duration: 動畫時長毫秒（選填，預設 1600）
  function animateCount(el){
    if(el.dataset.counted === '1') return;
    el.dataset.counted = '1';
    el.classList.add('counting');
    var target = parseFloat(el.getAttribute('data-count-up')) || 0;
    var suffix = el.getAttribute('data-count-suffix') || '';
    var prefix = el.getAttribute('data-count-prefix') || '';
    var duration = parseInt(el.getAttribute('data-count-duration')) || 1600;
    var hasDecimal = target % 1 !== 0;
    var startTime = null;
    function step(timestamp){
      if(!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      var display = hasDecimal ? current.toFixed(1) : Math.floor(current);
      el.textContent = prefix + display + suffix;
      if(progress < 1){
        requestAnimationFrame(step);
      } else {
        el.classList.remove('counting');
      }
    }
    requestAnimationFrame(step);
  }

  if('IntersectionObserver' in window){
    var countObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          animateCount(entry.target);
          countObserver.unobserve(entry.target);
        }
      });
    }, {threshold: 0.4});
    document.querySelectorAll('[data-count-up]').forEach(function(el){
      countObserver.observe(el);
    });
  } else {
    // 不支援 IntersectionObserver 的瀏覽器直接顯示結果
    document.querySelectorAll('[data-count-up]').forEach(function(el){
      el.textContent = (el.getAttribute('data-count-prefix') || '') + el.getAttribute('data-count-up') + (el.getAttribute('data-count-suffix') || '');
    });
  }
});
